import React from 'react';

export default function ErrorMessage(props) {
    let className = props.className || "";

    let result = null;
    if (props.message)
        result = <div className={'err mar-bot-5'}><small className={'text-left error ' + className}>{props.message}</small></div>;

    return result;
}